import React from "react";
import { connectHits } from "react-instantsearch-dom";
import { BasicDoc, Hit } from "react-instantsearch-core";
import SearchHitsContent from "./search-hits-content";

const SearchHits: React.FunctionComponent<any> = (props: {
  hits: Hit<BasicDoc>[];
  mode?: string | undefined;
  page?: number;
}): JSX.Element => {
  const { hits } = props;

  const digitalaVerktyg = hits.filter(
    (hit) => hit.content_type == "digitala verktyg",
  );
  const digitalaVerktygInternal = digitalaVerktyg.filter(
    (hit) => hit.origin == "internal",
  );
  const digitalaVerktygExternal = digitalaVerktyg.filter(
    (hit) => hit.origin == "external",
  );

  const utbildningar = hits.filter((hit) => hit.content_type == "utbildningar");
  const forskningPa5 = hits.filter(
    (hit) => hit.content_type == "forskning på 5",
  );

  return (
    <div className="sa-search-hits-container">
      {digitalaVerktygInternal.length > 0 && (
        <SearchHitsContent
          title="Digitala verktyg"
          description="Verktygen ger ett konkret stöd för att jobba med er arbetsmiljö. De innehåller kunskap, vägledning, checklistor och gruppaktiviteter, bland annat. Gå igenom verktygen från start till slut eller plocka de delar som passar er bäst!"
          items={digitalaVerktygInternal}
          id="digitalaVerktygInternal"
        />
      )}
      {utbildningar.length > 0 && (
        <SearchHitsContent
          title="Utbildningar"
          description="Utbildningarna planerar och genomför ni på arbetsplatsen i egen takt och efter egna behov. Använd dem i sin helhet – eller plocka delar att varva med ert eget utbildningsmaterial."
          items={utbildningar}
          id="utbildningar"
        />
      )}
      {forskningPa5.length > 0 && (
        <SearchHitsContent
          title="Forskning på 5"
          description="Forskning på 5 är korta aktiviteter, som passar perfekt på arbetsplatsträffen eller personalmötet. Här får ni titta på en kort film som berättar om aktuell forskning, och sedan prata ihop er om hur ni kan använda kunskaperna för att skapa bättre arbetsmiljö hos er."
          items={forskningPa5}
          id="forskningPa5"
        />
      )}
      {digitalaVerktygExternal.length > 0 && (
        <SearchHitsContent
          title="Våra vänners verktyg"
          description="De här verktygen kompletterar våra egna och är utvecklade av organisationer nära oss. De är också partsgemensamt godkända och kostnadsfria för dig att använda."
          items={digitalaVerktygExternal}
          id="digitalaVerktygExternal"
        />
      )}
    </div>
  );
};

export default connectHits(SearchHits);
